import dayjs from "dayjs";

export const todayDate = dayjs();
